import { fireEvent, render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";
import { CanvasRenderer } from "../CanvasRenderer";
import { TabsRenderer } from "./TabsRenderer";
import type { CanvasElement } from "../../../types";
import { tabPresentation } from "./tabPresentation";

it("shows the underline only on the selected tab", () => {
  const style = tabPresentation("underline")?.tab as any;
  expect(style["&::after"].bgcolor).toBe("transparent");
  expect(style["&.Mui-selected::after"].bgcolor).toBe("primary.500");
});

const panels = [
  { id: "one", label: "Details" },
  { id: "two", label: "Equipment" },
];
const grid = { columns: 12, rowHeight: 60, gap: 8, minRows: 4 };

describe.each(["runtime", "preview"] as const)(
  "%s tab presentation",
  (renderer) => {
    function show(tabStyle?: string) {
      const props = { containerType: "TABS", panels, tabStyle };
      if (renderer === "runtime") {
        render(
          <CanvasRenderer
            elements={[
              {
                id: "tabs",
                type: "container",
                props: props as never,
                gridColumn: 1,
                gridRow: 1,
                columnSpan: 12,
                rowSpan: 4,
              },
            ]}
            config={grid}
            mode="runtime"
          />,
        );
      } else {
        render(
          <TabsRenderer
            element={{ id: "tabs", props } as unknown as CanvasElement}
            allElements={[]}
            mode="edit"
          />,
        );
      }
    }

    it("uses a transparent underline strip when requested, retaining panel switching", () => {
      show("underline");
      expect(screen.getByRole("tablist")).toHaveStyle({
        borderBottomStyle: "solid",
      });
      const details = screen.getByRole("tab", { name: "Details" });
      expect(details).toHaveStyle({ backgroundColor: "transparent" });
      fireEvent.click(screen.getByRole("tab", { name: "Equipment" }));
      expect(screen.getByRole("tab", { name: "Equipment" })).toHaveAttribute(
        "aria-selected",
        "true",
      );
      expect(details).toHaveAttribute("aria-selected", "false");
      const equipment = screen.getByRole("tab", { name: "Equipment" });
      equipment.focus();
      fireEvent.keyDown(equipment, { key: "ArrowLeft" });
      expect(details).toHaveFocus();
      fireEvent.keyDown(details, { key: "Enter" });
      expect(details).toHaveAttribute("aria-selected", "true");
    });

    it.each([undefined, "unknown"])(
      "preserves the existing presentation for %s",
      (style) => {
        show(style);
        expect(screen.getByRole("tablist")).not.toHaveStyle({
          borderBottomStyle: "solid",
        });
        expect(screen.getByRole("tab", { name: "Details" })).toHaveAttribute(
          "aria-selected",
          "true",
        );
      },
    );
  },
);
